import { format } from 'date-fns';
import { timeForEach } from './timeForEach';
import { getDate } from './getDate';
import { DATE_FORMAT } from '../constants/dateTime';
export var getAvailableTimeSlots = function getAvailableTimeSlots(calendarDay, availableDates) {
  var availableTimeSlots = [];
  var date = getDate(calendarDay);
  var formattedDate = format(date, DATE_FORMAT);
  var availableDate = availableDates[formattedDate];
  if (!availableDate) {
    return availableTimeSlots;
  }
  availableDate.availableTimeIntervals.forEach(function (timeIntervals) {
    timeForEach(timeIntervals, availableDate.step / 60, function (time) {
      availableTimeSlots.push(time);
    });
  });
  return availableTimeSlots;
};